import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/site";

export default function FaqPreview() {
  return (
    <section className="mx-auto w-full max-w-content px-4 py-16 md:px-8 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14">
        <div>
          <p className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
            <span className="h-3 w-1 rounded-full bg-accent-500" aria-hidden="true" />
            常见问题
          </p>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于内容与投稿，你想知道的
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600">
            我们坚持只做一件事：把损害公共利益的套路讲清楚。下面这些问题，是读者问得最多的。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-500"
          >
            查看全部问题
            <i className="ri-arrow-right-line text-base" aria-hidden="true" />
          </Link>
        </div>
        <FaqAccordion items={faqs.slice(0, 4)} />
      </div>
    </section>
  );
}